var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"iframe"}},[_c('span',{on:{"click":_vm.backToScreen}},[_c('router-link',{staticClass:"back-link",attrs:{"to":_vm.backLinkSrc}},[_c('span',{staticClass:"fi flaticon-left-arrow"},[_vm._v("Back")])])],1),_vm._v(" "),_c('iframe',{attrs:{"src":_vm.src,"frameborder":"0"}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ee6a03a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IframeProject.vue
// module id = null
// module chunks = 